/*
  Окно внесения и правки на карточке счёта (20.10.2026): каркас, общий у начислений,
  оплат, проживающих и должников. Правило «три копии - в общий компонент»: четыре
  окна с одним устройством расходились бы в мелочах - в том, где показан отказ и как
  называется кнопка.

  Чек-лист формы (скилл `frontend`, правило 10):
  1. отказ сервера показывается ВНУТРИ окна, словами и с советом;
  2. успех закрывает окно и сразу обновляет список (`onSaved`);
  3. кнопка называется по тому, что сделает (`submitLabel`);
  4. закрытие сбрасывает состояние: окно создаётся заново при каждом открытии.
*/

import { useState } from 'react'

import { Notice } from '../Common.jsx'
import Modal from '../Modal.jsx'

export default function FormDialog({
  title,
  note,
  submitLabel,
  canSubmit = true,
  wide = false,
  onSubmit,
  onSaved,
  onClose,
  children,
}) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await onSubmit()
    } catch (failure) {
      setError(failure)
      setBusy(false)
      return
    }
    onSaved()
    onClose()
  }

  return (
    <Modal title={title} note={note} wide={wide} onClose={onClose} busy={busy}>
      <form onSubmit={submit}>
        <div className="modal__text">{children}</div>
        <Notice error={error} />
        <div className="row row--tight">
          {/* Выключена, пока обязательное не заполнено: свой выпадающий список
              браузер не проверяет (правило 6в скилла). */}
          <button type="submit" className="button" disabled={busy || !canSubmit}>
            {submitLabel}
          </button>
          <button type="button" className="button button--quiet" onClick={onClose} disabled={busy}>
            Отмена
          </button>
        </div>
      </form>
    </Modal>
  )
}
